import { androidOpen, isAndroidApp } from "./android";
import { iosOpenNewTab, isIOSApp } from "./ios";

/**
 * Opens a URL outside the app.
 *
 * The native shells do not load a foreign origin inside their webview: each
 * exposes an "open in the browser" bridge, and a `window.open` in there does
 * nothing a reader can see. On the web it is a new tab, with `noopener`
 * because the destination is another site and has no business holding a
 * handle on ours. `noreferrer` for the same reason, one step further: it also
 * keeps our URL out of the destination's `Referer`, which is already what the
 * two native branches do, because a link handed to the system browser carries
 * no referrer from this page. Without it the web branch would be the only one
 * that leaks it. Neither token turns the tab into a popup window.
 */
export function openExternalUrl(url: string): void {
  if (isIOSApp()) iosOpenNewTab(url);
  else if (isAndroidApp()) androidOpen(url);
  else window.open(url, "_blank", "noopener,noreferrer");
}
